import { render } from "./ChevronM.vue?vue&type=template&id=d5406c08"
const script = {}
script.render = render

export default script